import { render, staticRenderFns } from "./asignarRol.vue?vue&type=template&id=ba3584ca&scoped=true&"
import script from "./asignarRol.vue?vue&type=script&lang=js&"
export * from "./asignarRol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3584ca",
  null
  
)

export default component.exports